import { apiReports } from './apiReports'

const apiReportsGroup = {
	...apiReports,
}

export { apiReportsGroup }
